import React from 'react'
import './raised.scss';

const Raised = () => {
    return (
        <section className='main_Power' id='about'>
            <div className='innner_power'>
                <div className='custom-container'>
                    <div className='nnermore'>
                        <h2>Over $200 Million Raised by Web3 Projects<span> Featured on Our Platform, including: </span></h2>
                        <div className='cards_parents'>
                            <div className='coin_cards'>
                                <div className='inner_coin'>
                                    <img src='\assets\dop.svg' />
                                    <div className='midle_coin'>
                                        <h3>DOP</h3>
                                        <p>DOP</p>
                                    </div>
                                </div>
                                <div className='bottom_coin'>
                                    <h4>Total Raised</h4>
                                    <h5>$160M</h5>
                                </div>
                                <h6>Pioneering zero-knowledge proofs on Ethereum L1</h6>
                            </div>
                            <div className='coin_cards'>
                                <div className='inner_coin'>
                                    <img src='\assets\incentive.svg' />
                                    <div className='midle_coin'>
                                        <h3>Incentiv</h3>
                                        <p>INC</p>
                                    </div>
                                </div>
                                <div className='bottom_coin'>
                                    <h4>Total Raised</h4>
                                    <h5>$25M</h5>
                                </div>
                                <h6>Layer 1 blockchain focused on accessibility and user rewards</h6>
                            </div>
                            <div className='coin_cards'>
                                <div className='inner_coin'>
                                    <img src='\assets\leia.svg' />
                                    <div className='midle_coin'>
                                        <h3>LEIA Games</h3>
                                        <p>LEIA</p>
                                    </div>
                                </div>
                                <div className='bottom_coin'>
                                    <h4>Total Raised</h4>
                                    <h5>$3.3M</h5>
                                </div>
                                <h6>First Web3 casual mobile games platform with skill-based rewards</h6>
                            </div>
                            <div className='coin_cards'>
                                <div className='inner_coin'>
                                    <img src='\assets\ai.svg' />
                                    <div className='midle_coin'>
                                        <h3>Olympus AI</h3>
                                        <p>OAI</p>
                                    </div>
                                </div>
                                <div className='bottom_coin'>
                                    <h4>Total Raised</h4>
                                    <h5>$2.1M</h5>
                                </div>
                                <h6>Integrated AI models platform</h6>
                            </div>
                            <div className='coin_cards'>
                                <div className='inner_coin'>
                                    <img src='\assets\rain.svg' />
                                    <div className='midle_coin'>
                                        <h3>Rain</h3>
                                        <p>RAIN</p>
                                    </div>
                                </div>
                                <div className='bottom_coin'>
                                    <h4>Total Raised</h4>
                                    <h5>$1.6M</h5>
                                </div>
                                <h6>Decentralized outcome markets platform</h6>
                            </div>
                            <div className='coin_cards'>
                                <div className='inner_coin'>
                                    <img src='\assets\nova.svg' />
                                    <div className='midle_coin'>
                                        <h3>Astra Nova</h3>
                                        <p>$RVV</p>
                                    </div>
                                </div>
                                <div className='bottom_coin'>
                                    <h4>Total Raised</h4>
                                    <h5>$1.65M</h5>
                                </div>
                                <h6>AGI-driven gaming ecosystem that evolves with player behavior</h6>
                            </div>
                            <div className='coin_cards'>
                                <div className='inner_coin'>
                                    <img src='\assets\luckify.svg' />
                                    <div className='midle_coin'>
                                        <h3>Luckify</h3>
                                        <p>LUCK</p>
                                    </div>
                                </div>
                                <div className='bottom_coin'>
                                    <h4>Total Raised</h4>
                                    <h5>$670K</h5>
                                </div>
                                <h6>Redefining chance-based gaming by putting fairness on-chain</h6>
                            </div>
                            <div className='coin_cards'>
                                <div className='inner_coin'>
                                    <img src='\assets\matchain.svg' />
                                    <div className='midle_coin'>
                                        <h3>Matchain</h3>
                                        <p>Genesis License</p>
                                    </div>
                                </div>
                                <div className='bottom_coin'>
                                    <h4>Total Raised</h4>
                                    <h5>$380K</h5>
                                </div>
                                <h6>Scalable and decentralized AI chain prioritizing secure identity</h6>
                            </div>
                            <div className='coin_cards'>
                                <div className='inner_coin'>
                                    <img src='\assets\nfa.svg' />
                                    <div className='midle_coin'>
                                        <h3>NFA</h3>
                                        <p>NFA</p>
                                    </div>
                                </div>
                                <div className='bottom_coin'>
                                    <h4>Total Raised</h4>
                                    <h5>$289K</h5>
                                </div>
                                <h6>Transforming crypto investment discovery with advanced AI</h6>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </section>
    )
}

export default Raised
